import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BazisControlValueAccessor } from '@bazis/form/components/control-value-accessor.component';

@UntilDestroy()
@Component({
    selector: 'bazis-estimated-value',
    templateUrl: './estimated-value.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisEstimatedValueComponent extends BazisControlValueAccessor {
    @Input() estimatedValue: any;

    @Input() entityType: string;

    @Input() nameField: string;

    @Input() displayTpl: TemplateRef<any>;

    public field = new FormControl('');

    valueChanges$ = this.field.valueChanges.pipe(
        tap((value) => {
            if (!value) this.onChange(this.estimatedValue);
            else this.onChange(value);
        }),
    );

    // ngOnInit() {
    //     if (this.ngControl.control instanceof EntityFormControl) {
    //         BazisFormService.getPropertiesFromConfig(this, this.ngControl.control.$config);
    //     }
    // }

    public setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            this.field.disable();
        } else {
            this.field.enable();
        }
    }

    public writeValue(value: any): void {
        this.field.setValue(value, { emitEvent: false });
    }
}
